<template>
    <v-jumbotron color="grey lighten-2">
        <v-container fill-height>
            <v-layout align-center>
                <v-flex>
                    <h3 class="display-3 mb-4">Hey There!</h3>
                    <span class="subheading">Welcome to LOKL (currently in beta)!
                        Our mission is to help support local restaurants by promoting deals during their slowest times.
                        If you find yourself eating a late lunch, early dinner, or feel like exploring new restaurants, we're sure there's a local spot that would love to win your business.
                        Interested? Come on in!
                    </span>
                    <v-divider class="my-3"></v-divider>
                    <v-row>
                        <v-col>
                            <div class="title mb-3 text-sm-center">Explore Our Promos</div>
                            <div class="text-sm-center">
                                <v-btn large color="warning" class="mx-0" :to="{name:'Promos'}">Explore!</v-btn>
                            </div>
                            <div class="title mt-3 mb-3 text-sm-center">Learn How it Works</div>
                            <div class="text-sm-center">
                                <v-btn large color="info" class="mx-0" :to="{name:'Explain'}">Learn!</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-flex>
            </v-layout>
        </v-container>
    </v-jumbotron>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>